import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Spectrumservices() {
  return (
    <section className="spectrum_services mobile_app_innovators p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={11}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Transforming Industries with Advanced{" "}
              <span>Mobile App Innovations</span>
            </h2>
            <p>
              We drive transformation by developing mobile apps that harness
              advanced technologies, enabling businesses to disrupt industries
              and stay ahead. Our mobile app development services are engineered
              for precision to tackle complex challenges and deliver unmatched
              performance.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-3 mb-md-4">
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/services-usa/mobile-app/iot_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={70}
                  height={70}
                />
              </div>
              <div className="spec_services_head">
                <h5>Internet of Things</h5>
              </div>
              <p>
                Our mobile application development company integrates IoT to
                enable real-time device communication and advanced data
                processing. We optimize apps for industrial operations through
                predictive analytics, zero downtime, and automation.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-3 mb-md-4">
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/services-usa/mobile-app/ar_vr_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={70}
                  height={70}
                />
              </div>
              <div className="spec_services_head">
                <h5>AR & VR</h5>
              </div>
              <p>
                We develop AR and VR apps that deliver immersive, high-fidelity
                experiences. Using spatial computing and interactive models, our
                solutions transform user engagement in sectors like retail,
                training, and simulation.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-3 mb-md-4">
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/services-usa/mobile-app/five_g_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={70}
                  height={70}
                />
              </div>
              <div className="spec_services_head">
                <h5>5G Technology</h5>
              </div>
              <p>
                Our apps leverage 5G’s ultra-low latency and high-speed
                capabilities for real-time data transfer and enhanced
                performance in demanding environments. This is critical for
                applications in telemedicine, smart cities, and autonomous
                systems.
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={4}
            xxl={4}
            className="mb-3 mb-md-4 mb-xl-0"
          >
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/services-usa/mobile-app/ai_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={70}
                  height={70}
                />
              </div>
              <div className="spec_services_head">
                <h5>AI & ML</h5>
              </div>
              <p>
                We embed AI and ML into mobile apps for real-time data-driven
                decision-making, predictive analytics, and intelligent
                automation. Our solutions enable dynamic user interactions and
                adaptive experiences that keep businesses competitive.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-3 mb-md-0">
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/services-usa/mobile-app/blockchain_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={70}
                  height={70}
                />
              </div>
              <div className="spec_services_head">
                <h5>Blockchain</h5>
              </div>
              <p>
                Our blockchain-enabled apps ensure secure, decentralized
                operations. We address challenges in data integrity,
                traceability, and security, making them ideal for digital
                identity, secure transactions, and tamper-proof records.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/services-usa/mobile-app/cloud_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={70}
                  height={70}
                />
              </div>
              <div className="spec_services_head">
                <h5>Cloud Computing Integration</h5>
              </div>
              <p>
                We integrate cloud platforms to enhance app scalability,
                resilience, and security. Our solutions ensure high
                availability, seamless updates, and robust disaster recovery,
                vital for enterprise-grade mobile applications.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Spectrumservices;
